import { setTerms } from './helpers';

export const setContainWords = setTerms('description_include');
